
    import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';
    import palettes from '@/components/editor/config/palettes';

    @Component
    export default class OptionsFieldsPalette extends Vue {
        //TODO: colorpicker

        @Prop() value!: any;
        palettes = palettes;

        paletteObj = {
            bg: this.value.bg,
            icon: this.value.icon,
            trigger: this.value.trigger,
            text: this.value.text
        };

        @Watch('paletteObj', { immediate: true, deep: true })
        onPaletteChanged(val, oldVal) {
            this.$emit('input', val);
        }

        isEqual(one, two) {
            let equal = true;
            for (let i in one) {
                let val1 = one[i];
                let val2 = two[i];

                if (val1 !== val2) {
                    equal = false;
                } else {
                }
            }
            return equal;
        }

        get selected() {
            //
            for (let i in this.palettes) {
                if (
                    palettes[i].value &&
                    this.isEqual(palettes[i].value, this.paletteObj)
                ) {
                    return palettes[i].value;
                }
            }
            return this.paletteObj;
        }

        set selected(val) {
            this.paletteObj = val;
        }
    }
